module.exports = __webpack_public_path__ + "static/egyptian-pillowcase-grey-2-45b84e5fec5588b4bf3ffab96fb5d56f.webp";